import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import GoodsListContext, {useGoodsListContext, GoodsListController} from "../../../../reducer/moduleReducer/goodsList";
import Tabs from "../../../../publicComponent/Tabs";
import Buffer from "../../../../publicComponent/Buffer";
import {useTranslation, getI18n} from "react-i18next";
import {Fragment, useEffect, useState} from "react";
import Pagination from "../../../../publicComponent/Pagination";
import Drawer from "../../../../publicComponent/Drawer";
import Mobile from "../../../../publicComponent/Mobile";
import RightIconImg from '../../../../icon/right.png';
import PC from "../../../../publicComponent/PC";

function RightIcon({ arr = [], index, activeIndex }) {
  return (
    arr && arr.length > 0 &&
    <img src={RightIconImg}
         style={{
           verticalAlign: 'middle',
           transition: 'transform 0.15s',
           transform: `rotate(${activeIndex === index ? 90 : 0}deg)`
         }}
         className="w-[12px] inline-block ml-[10px]"/>
  );
}

function SecondTabs({ arr, tabHandle, active, i }) {
  const [activeIndex, setActiveIndex] = useState(null);
  
  return (
    arr && arr.length > 0 ?
      <div className="ml-[20px]">
        {
          arr.map((child, index) => (
            <Fragment key={index}>
              <a
                onClick={() => {
                  setActiveIndex(index);
                  tabHandle(child.categoryId, child.categoryName, i, 'second', child.children);
                }}
                className={'relative cursor-pointer block py-[12px] ' +
                `${active === child.categoryId ? 'font-bold' : ''}`}
              >
                {child.categoryName}
                <RightIcon
                  arr={child.children}
                  index={index}
                  activeIndex={activeIndex}/>
              </a>
              {
                child.children &&
                child.children.length &&
                activeIndex > 0 &&
                activeIndex === index ?
                  <div className="ml-[20px]">
                    {
                      child.children.map((item, $index) => (
                        <a key={$index}
                           onClick={() => {
                             tabHandle(item.categoryId, item.categoryName, i, 'third');
                           }}
                           className={'relative cursor-pointer block py-[12px] ' +
                           `${active === item.categoryId ? 'font-bold' : ''}`}
                        >{item.categoryName}</a>
                      ))
                    }
                  </div> : null
              }
            
            </Fragment>
          ))
        }
      
      </div> : null
  );
}

function ListWrap(
  {
    gotoProductDetail, getGoodsList
  }
) {
  const { state } = useGoodsListContext();
  const { goodsListLoading, goodsList, total, query } = state;
  const { t } = useTranslation();
  const lang = getI18n().language;
  return (
    <>
      <Buffer.Loading loading={goodsListLoading}/>
      {
        goodsList.length > 0
          ? <>
            <div className="relative grid grid-cols-3 xlg:gap-12 md:gap-7 pb-[20px]
                        mdmax:grid-cols-2 mdmax:gap-4 md:py-[12px] mdmax:mx-[3%]">
              
              {
                goodsList.map((item, i) => (
                  <div className="relative inline-block cursor-pointer grid grid-rows-1 gap-0"
                       onClick={() => gotoProductDetail(item.itemId)}
                       key={i}>
                    <div className="cursor-pointer overflow-hidden mdmax:rounded-[10px] row-span-1 bg-white flex items-center">
                      <img src={item.mainPicView}/>
                    </div>
                    <div className="left-0 text-left pt-[12px] bottom-[32px] mdmax:bottom-[15px] w-[100%]">
                      <p className="text-lg line-clamp-1 cursor-pointer"
                         style={{ lineHeight: '18px' }}>
                        {lang === "en" ? item.itemEnName : item.itemName}
                      </p>
                      <p className="text-2xl mdmax:mt-[5px] text-[#999] text-[14px] mb-[15px]">${item.minPrice}</p>
                    </div>
                  </div>
                ))
              }
            </div>
            <Pagination total={total}
                        current={query.page}
                        pageSize={query.limit}
                        onChange={(page) => getGoodsList({ page })}
                        className="md:mb-[100px] mdmax:pb-[100px]"/>
          </>
          : <Buffer.Empty content={t('抱歉！暂时还没有商品')}/>
      }
    </>
  );
}

function GoodsListWrap() {
  const lang = getI18n().language;
  const [categoryName, setCategoryName] = useState(lang === 'en' ? 'ALL' : '全部');
  const [categoryDrawer, setCategoryDrawer] = useState(false);
  const { setCategorysActive, gotoProductDetail, getGoodsList, getPriceArea, setMaxPriceHandle, setMinPriceHandle } = GoodsListController();
  const { state } = useGoodsListContext();
  const { categorys, categoryActive, minPrice, maxPrice } = state;
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();
  
  
  const tabHandle = (categoryId, categoryName, index, type, children) => {
    setCategorysActive(categoryId, type);
    console.log(type,categoryId);
    setCategoryName(categoryName);
    setActiveIndex(index);
    if (!children || children.length <= 0) {
      setCategoryDrawer(false);
    }
  };
  
  return (
    <Navigator.container className="container-center md:flex md:mt-[50px]">
      <PC className="md:mt-[25px] pr-[50px] flex-none w-[240px]">
        <p className="border-b border-[#666] text-[15px] pb-[15px] mb-[15px]">{t('分类')}</p>
        <p className="border-b border-[#666] text-[15px] pb-[15px] mb-[15px]">
          {t('价格')}:
          <input type="number"
                 onChange={(e) => setMinPriceHandle(e.target.value)}
                 onKeyUp={getPriceArea}
                 value={minPrice}
                 placeholder={t("Min")}
                 className="inline-block w-[50px] ml-[5px] p-[5px] text-[13px] border-[1px] border-[#999]"/>
          <span style={{ margin: '0 8px', fontSize: 16 }}>~</span>
          <input type="number"
                 onChange={(e) => setMaxPriceHandle(e.target.value)}
                 onKeyUp={getPriceArea}
                 value={maxPrice}
                 placeholder={t("Max")}
                 className="inline-block w-[50px] ml-[5px] p-[5px] text-[13px] border-[1px] border-[#999]"/>
        </p>
        <Tabs tabs={state.categorys}
              active={state.categoryActive}
              onChange={setCategorysActive}
              style={{ border: 'none', paddingLeft: 0, }}
              tabsActiveColor="transparent"
              tabsStyle={{ paddingLeft: 0, display: 'block', textAlign: 'left' }}
              tabKey={{ label: lang === 'en' ? 'categoryEnName' : 'categoryName', value: 'categoryId' }}/>
      </PC>
      
      <Mobile className="md:mt-[25px] border-b py-[12px] justify-between items-center flex">
        <p className="px-[15px] text-[14px] inline-block"
           onClick={() => setCategoryDrawer(true)}>
          {t('分类')}
          <i className="iconfont icon-bottom text-[12px] text-[#999] ml-[10px]"/>
          {
            categoryName && <span className="ml-[15px]">{categoryName}</span>
          }
        </p>
        <p className="mr-[20px]">
          {t('价格')}:
          <input type="number"
                 onChange={(e) => setMinPriceHandle(e.target.value)}
                 onKeyUp={getPriceArea}
                 value={minPrice}
                 placeholder={"Min"}
                 className="inline-block w-[50px] ml-[5px] py-[3px] px-[5px] text-[12px] border-[1px] border-[#999]"/>
          <span style={{ margin: '0 8px', fontSize: 16 }}>~</span>
          <input type="number"
                 onChange={(e) => setMaxPriceHandle(e.target.value)}
                 onSubmit={getPriceArea}
                 placeholder={"Max"}
                 className="inline-block w-[50px] ml-[5px] py-[3px] px-[5px] text-[12px] border-[1px] border-[#999]"/>
        </p>
        <Drawer visible={categoryDrawer}
                width={'75vw'}
                onClose={setCategoryDrawer}
                left>
          <div className="pt-[80px] flex flex-col">
            <i onClick={() => setCategoryDrawer(false)}
               className="iconfont icon-delete text-[#666] text-[16px] mb-[15px]"></i>
            {
              categorys.map((item, i) => {
                let active = item.categoryId === categoryActive;
                return (
                  <div key={i}>
                    <a className="text-[14px] py-[12px] block"
                       onClick={() => {
                         setCategorysActive(item.categoryId);
                         setCategoryName(lang === 'en' ? item.categoryEnName : item.categoryName);
                         setActiveIndex(i);
                         if (!item.children || item.children.length <= 0) {
                           setCategoryDrawer(false);
                         }
                       }}
                       style={{ fontWeight: active ? 'bold' : 'normal' }}>
                      {lang === 'en' ? item.categoryEnName : item.categoryName}
                      <RightIcon
                        arr={item.children}
                        index={i}
                        activeIndex={activeIndex}/>
                    </a>
                    {
                      activeIndex !== null && activeIndex === i &&
                      <SecondTabs i={i}
                                  arr={item.children}
                                  tabHandle={tabHandle}
                                  active={categoryActive}/>
                    }
                  </div>
                );
              })
            }
          </div>
        </Drawer>
      </Mobile>
      
      <div className="relative flex-1 pt-[12px]">
        <ListWrap gotoProductDetail={gotoProductDetail}
                  getGoodsList={getGoodsList}/>
      </div>
    </Navigator.container>
  );
}

export default function GoodsList() {
  
  return (
    <div className="md:bg-[#f4f4f6]">
      <HeaderMall9/>
      <Navigator title={'产品分类'}/>
      <GoodsListContext>
        <GoodsListWrap/>
      </GoodsListContext>
      <FooterMall9/>
    </div>
  );
}
